// import {
//   createContext,
//   useContext,
//   useState,
//   useEffect,
//   useCallback,
// } from "react";
// import { useAuth } from "./AuthContext";
// import CartsApiService from "../services/CartsApiService";
// import OrderApiService from "../services/OrderApiService";
// import { toast } from "react-toastify";

// const CartContext = createContext();

// export const useCart = () => {
//   const context = useContext(CartContext);
//   if (!context) {
//     throw new Error("useCart must be used within CartProvider");
//   }
//   return context;
// };

// export const CartProvider = ({ children }) => {
//   const { user, token } = useAuth();
//   const [cartItems, setCartItems] = useState([]);
//   const [isCartOpen, setIsCartOpen] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [cartFromBackend, setCartFromBackend] = useState(null);
//   const [checkoutSession, setCheckoutSession] = useState(null);

//   // Transform backend cart items to frontend format
//   const transformBackendToFrontend = useCallback((backendItems) => {
//     if (!backendItems || !Array.isArray(backendItems)) return [];

//     const frontendItems = [];

//     backendItems.forEach((item) => {
//       const baseItem = {
//         id: item.id,
//         product: {
//           id: item.product?.id || 0,
//           nameEn: item.product?.name_en || item.product?.nameEn || "",
//           nameAr: item.product?.name_ar || item.product?.nameAr || "",
//           images:
//             item.product?.images?.map((img) => ({
//               image_url: img.imageUrl || img.image_url || "",
//             })) || [],
//           brand: item.product?.brand
//             ? {
//                 id: item.product.brand.id,
//                 nameEn:
//                   item.product.brand.nameEn || item.product.brand.name_en || "",
//                 nameAr:
//                   item.product.brand.nameAr || item.product.brand.name_ar || "",
//                 imageUrl:
//                   item.product.brand.imageUrl ||
//                   item.product.brand.image_url ||
//                   null,
//               }
//             : null,
//           descriptionEn:
//             item.product?.description_en || item.product?.descriptionEn || "",
//           descriptionAr:
//             item.product?.description_ar || item.product?.descriptionAr || "",
//           category: item.product?.category || null,
//           subCategory:
//             item.product?.subCategory || item.product?.sub_category || null,
//           collection: item.product?.collection || null,
//         },
//         variant: {
//           id: item.variant?.id || 0,
//           color: item.variant?.color || null,
//           size: item.variant?.size || null,
//           price: item.variant?.price || 0,
//           discountPrice: item.variant?.discountPrice || null,
//           availableQuantity: item.variant?.availableQuantity || 0,
//           withoutBoxQuantity: item.variant?.withoutBoxQuantity || 0,
//           quantity: item.variant?.quantity || 0,
//           sku: item.variant?.sku || "",
//         },
//         itemTotal: item.itemTotal || 0,
//       };

//       // Add with-box item if quantity > 0
//       if (item.quantity && item.quantity > 0) {
//         frontendItems.push({
//           ...baseItem,
//           quantity: item.quantity,
//           withoutBox: false,
//         });
//       }

//       // Add without-box item if withoutBoxQuantity > 0
//       if (item.withoutBoxQuantity && item.withoutBoxQuantity > 0) {
//         frontendItems.push({
//           ...baseItem,
//           quantity: item.withoutBoxQuantity,
//           withoutBox: true,
//         });
//       }
//     });

//     return frontendItems;
//   }, []);

//   // ✅ IMPROVED: Sync local cart to backend
//   const syncLocalCartToBackend = async (localCartItems) => {
//     try {
//       console.log("🔄 Starting cart sync...");
      
//       // ✅ STEP 1: Get existing backend cart first
//       let backendCart;
//       try {
//         backendCart = await CartsApiService.getCart();
//       } catch (error) {
//         console.error("Error fetching backend cart:", error);
//         // If backend cart doesn't exist, create empty one
//         backendCart = { items: [] };
//       }

//       // ✅ STEP 2: Create a map of existing backend items
//       const backendItemsMap = new Map();
      
//       if (backendCart.items && backendCart.items.length > 0) {
//         backendCart.items.forEach((item) => {
//           // Create keys for both with-box and without-box variants
//           if (item.quantity && item.quantity > 0) {
//             const keyWith = `${item.variant.id}-with`;
//             backendItemsMap.set(keyWith, {
//               variantId: item.variant.id,
//               quantity: item.quantity,
//               withoutBox: false,
//             });
//           }
          
//           if (item.withoutBoxQuantity && item.withoutBoxQuantity > 0) {
//             const keyWithout = `${item.variant.id}-without`;
//             backendItemsMap.set(keyWithout, {
//               variantId: item.variant.id,
//               quantity: item.withoutBoxQuantity,
//               withoutBox: true,
//             });
//           }
//         });
//       }

//       // ✅ STEP 3: Group local items by variantId and withoutBox
//       const localItemsMap = new Map();
      
//       localCartItems.forEach((item) => {
//         const key = `${item.variant.id}-${item.withoutBox ? "without" : "with"}`;
//         if (localItemsMap.has(key)) {
//           // Sum quantities if duplicate
//           localItemsMap.get(key).quantity += item.quantity;
//         } else {
//           localItemsMap.set(key, {
//             productVariantId: item.variant.id,
//             quantity: item.quantity,
//             withoutBox: item.withoutBox || false,
//           });
//         }
//       });

//       // ✅ STEP 4: Process each local item
//       for (const [key, localItem] of localItemsMap.entries()) {
//         const backendItem = backendItemsMap.get(key);

//         if (backendItem) {
//           // Item exists in backend
//           // ✅ Compare quantities and update if local has more
//           if (localItem.quantity > backendItem.quantity) {
//             console.log(
//               `📦 Updating quantity for variant ${localItem.productVariantId} (${localItem.withoutBox ? "without box" : "with box"}): ${backendItem.quantity} → ${localItem.quantity}`
//             );
            
//             try {
//               await CartsApiService.updateCartItemByVariant(
//                 localItem.productVariantId,
//                 localItem.quantity,
//                 localItem.withoutBox
//               );
//             } catch (error) {
//               console.error(`Error updating variant ${localItem.productVariantId}:`, error);
//             }
//           } else {
//             console.log(
//               `✅ Variant ${localItem.productVariantId} (${localItem.withoutBox ? "without box" : "with box"}) already in backend with equal/higher quantity. Skipping.`
//             );
//           }
//         } else {
//           // Item doesn't exist in backend - add it
//           console.log(
//             `➕ Adding new item to backend: variant ${localItem.productVariantId} (${localItem.withoutBox ? "without box" : "with box"}), quantity: ${localItem.quantity}`
//           );
          
//           try {
//             await CartsApiService.addToCart(
//               localItem.productVariantId,
//               localItem.quantity,
//               localItem.withoutBox
//             );
//           } catch (error) {
//             console.error(`Error adding variant ${localItem.productVariantId}:`, error);
//           }
//         }
//       }

//       console.log("✅ Cart sync completed successfully!");
//     } catch (error) {
//       console.error("❌ Error syncing cart to backend:", error);
//     }
//   };

//   // Initialize cart based on auth state
//   useEffect(() => {
//     const initializeCart = async () => {
//       if (token && user) {
//         // User is logged in - load from backend
//         try {
//           setIsLoading(true);

//           // Check for local cart to sync
//           const localCart = localStorage.getItem("cart");
//           if (localCart) {
//             const localCartItems = JSON.parse(localCart);
//             if (localCartItems.length > 0) {
//               console.log("📦 Found local cart with items, syncing to backend...");
//               // Sync local cart to backend (improved version)
//               await syncLocalCartToBackend(localCartItems);
//               // Clear localStorage after sync
//               localStorage.removeItem("cart");
//               console.log("🗑️ Local cart cleared after sync");
//             }
//           }

//           // Load cart from backend
//           const backendCart = await CartsApiService.getCart();
//           setCartFromBackend(backendCart);

//           // Set cart items from backend (transformed)
//           const transformedItems = transformBackendToFrontend(
//             backendCart.items
//           );
//           setCartItems(transformedItems);
//         } catch (error) {
//           console.error("Error loading cart from backend:", error);
//           // Fallback to localStorage if backend fails
//           loadCartFromLocalStorage();
//         } finally {
//           setIsLoading(false);
//         }
//       } else {
//         // User is not logged in - load from localStorage
//         loadCartFromLocalStorage();

//         // Check for existing checkout session
//         const savedCheckoutSession = localStorage.getItem("checkoutSession");
//         if (savedCheckoutSession) {
//           try {
//             setCheckoutSession(JSON.parse(savedCheckoutSession));
//           } catch (e) {
//             console.error("Error parsing checkout session:", e);
//           }
//         }
//       }
//     };

//     initializeCart();
//   }, [token, user, transformBackendToFrontend]);

//   // Load cart from localStorage
//   const loadCartFromLocalStorage = () => {
//     const savedCart = localStorage.getItem("cart");
//     if (savedCart) {
//       try {
//         setCartItems(JSON.parse(savedCart));
//       } catch (error) {
//         console.error("Error loading cart from localStorage:", error);
//       }
//     }
//   };

//   // Save to localStorage only if user is not logged in
//   useEffect(() => {
//     if (!token) {
//       localStorage.setItem("cart", JSON.stringify(cartItems));
//     }
//   }, [cartItems, token]);

//   // Prepare cart items for checkout
//   const prepareCheckoutItems = useCallback(() => {
//     if (!cartItems || cartItems.length === 0) return [];

//     return cartItems.map((item) => ({
//       productVariantId: item.variant.id,
//       quantity: item.quantity,
//       withoutBox: item.withoutBox || false,
//     }));
//   }, [cartItems]);

//   // Check cart items availability before checkout
//   const checkCartAvailability = useCallback(async () => {
//     try {
//       const checkoutItems = prepareCheckoutItems();

//       if (checkoutItems.length === 0) {
//         return { success: true, unavailableItems: [] };
//       }

//       const result = await OrderApiService.checkCartAvailability(checkoutItems);
//       return result;
//     } catch (error) {
//       console.error("Error checking cart availability:", error);
//       return { success: false, error: error.message };
//     }
//   }, [prepareCheckoutItems]);

//   // Update cart with available quantities
//   const updateCartWithAvailableQuantities = useCallback(
//     (updatedCartItems) => {
//       if (token) {
//         // For logged-in users: refresh cart from backend
//         const refreshCart = async () => {
//           try {
//             const backendCart = await CartsApiService.getCart();
//             setCartFromBackend(backendCart);
//             const transformedItems = transformBackendToFrontend(backendCart.items);
//             setCartItems(transformedItems);
//           } catch (error) {
//             console.error("Error refreshing cart:", error);
//           }
//         };
//         refreshCart();
//       } else {
//         // For guest users: update localStorage cart
//         setCartItems((prevItems) => {
//           const updatedItems = [...prevItems];

//           updatedCartItems.forEach((update) => {
//             const itemIndex = updatedItems.findIndex(
//               (item) =>
//                 item.variant.id === update.productVariantId &&
//                 item.withoutBox === update.withoutBox
//             );

//             if (itemIndex !== -1) {
//               if (update.shouldRemove || update.quantity === 0) {
//                 updatedItems.splice(itemIndex, 1);
//               } else if (update.quantity > 0) {
//                 updatedItems[itemIndex] = {
//                   ...updatedItems[itemIndex],
//                   quantity: update.quantity,
//                 };
//               }
//             }
//           });

//           localStorage.setItem("cart", JSON.stringify(updatedItems));
//           return updatedItems;
//         });
//       }
//     },
//     [token, transformBackendToFrontend]
//   );

//   // Initiate checkout process
//   const initiateCheckout = useCallback(async () => {
//     try {
//       setIsLoading(true);

//       const checkoutItems = prepareCheckoutItems();
//       const useCartItems = !!user;

//       const response = await OrderApiService.initiateCheckout(
//         useCartItems ? [] : checkoutItems,
//         useCartItems
//       );

//       if (!response.success) {
//         if (response.updatedCartItems && response.updatedCartItems.length > 0) {
//           updateCartWithAvailableQuantities(response.updatedCartItems);
//         } else if (response.unavailableItems && response.unavailableItems.length > 0) {
//           if (user && token) {
//             try {
//               const backendCart = await CartsApiService.getCart();
//               setCartFromBackend(backendCart);
//               const transformedItems = transformBackendToFrontend(backendCart.items);
//               setCartItems(transformedItems);
//             } catch (error) {
//               console.error("Error refreshing cart:", error);
//             }
//           }
//         }

//         return {
//           success: false,
//           unavailableItems: response.unavailableItems || [],
//           errorMessage:
//             response.errorMessage ||
//             "Some items are not available in the requested quantities",
//         };
//       }

//       setCheckoutSession({
//         checkoutId: response.checkoutId,
//         expiresAt: response.expiresAt,
//         expiresIn: response.expiresIn,
//       });

//       if (!user) {
//         localStorage.setItem(
//           "checkoutSession",
//           JSON.stringify({
//             checkoutId: response.checkoutId,
//             expiresAt: response.expiresAt,
//             expiresIn: response.expiresIn,
//           })
//         );

//         localStorage.setItem("checkoutCartItems", JSON.stringify(checkoutItems));
//       }

//       return {
//         success: true,
//         checkoutId: response.checkoutId,
//         expiresAt: response.expiresAt,
//         expiresIn: response.expiresIn,
//       };
//     } catch (error) {
//       console.error("Error initiating checkout:", error);
//       return {
//         success: false,
//         errorMessage: error.message || "Failed to initiate checkout",
//       };
//     } finally {
//       setIsLoading(false);
//     }
//   }, [prepareCheckoutItems, user, token, updateCartWithAvailableQuantities, transformBackendToFrontend]);

//   // Clear checkout session
//   const clearCheckoutSession = useCallback(() => {
//     setCheckoutSession(null);
//     localStorage.removeItem("checkoutSession");
//     localStorage.removeItem("checkoutCartItems");
//   }, []);

//   // Validate checkout session
//   const validateCheckoutSession = useCallback(async (checkoutId) => {
//     try {
//       const session = await OrderApiService.getCheckoutSession(checkoutId);

//       if (
//         session.status === "PENDING" &&
//         new Date(session.expiresAt) > new Date()
//       ) {
//         return { valid: true, session };
//       }

//       return { valid: false, session };
//     } catch (error) {
//       console.error("Error validating checkout session:", error);
//       return { valid: false, error: error.message };
//     }
//   }, []);

//   // Add item to cart
//   const addToCart = useCallback(
//     async (
//       product,
//       variant,
//       quantity = 1,
//       withoutBox = false,
//       autoOpen = true
//     ) => {
//       try {
//         setIsLoading(true);

//         const maxQuantity = withoutBox
//           ? (variant.withoutBoxQuantity - variant.withoutBoxReservedQuantity)
//           : (variant.quantity - variant.reservedQuantity);
//         let validatedQuantity = quantity;

//         if (validatedQuantity <= 0) {
//           toast.error(
//             withoutBox
//               ? "عذراً، هذا المنتج غير متوفر بدون صندوق حالياً"
//               : "عذراً، هذا المنتج غير متوفر حالياً"
//           );
//           setIsLoading(false);
//           return;
//         }

//         if (quantity > maxQuantity) {
//           validatedQuantity = maxQuantity;

//           const message = withoutBox
//             ? `الكمية المتاحة بدون صندوق هي ${maxQuantity} فقط. تم تعديل الكمية.`
//             : `الكمية المتاحة هي ${maxQuantity} فقط. تم تعديل الكمية.`;

//           toast.warning(message);
//         }

//         if (token) {
//           const response = await CartsApiService.addToCart(
//             variant.id,
//             validatedQuantity,
//             withoutBox
//           );

//           setCartFromBackend(response);
//           const transformedItems = transformBackendToFrontend(response.items);
//           setCartItems(transformedItems);
//         } else {
//           setCartItems((prevItems) => {
//             const existingItemIndex = prevItems.findIndex(
//               (item) =>
//                 item.product.id === product.id &&
//                 item.variant.id === variant.id &&
//                 item.withoutBox === withoutBox
//             );

//             if (existingItemIndex > -1) {
//               const updatedItems = [...prevItems];
//               const newQuantity =
//                 updatedItems[existingItemIndex].quantity + validatedQuantity;

//               if (newQuantity > maxQuantity) {
//                 updatedItems[existingItemIndex].quantity = maxQuantity;
//               } else {
//                 updatedItems[existingItemIndex].quantity = newQuantity;
//               }

//               return updatedItems;
//             } else {
//               return [
//                 ...prevItems,
//                 {
//                   id: Date.now(),
//                   product,
//                   variant,
//                   quantity: validatedQuantity,
//                   withoutBox,
//                 },
//               ];
//             }
//           });

//           clearCheckoutSession();
//         }

//         if (autoOpen) {
//           setIsCartOpen(true);
//         }
//       } catch (error) {
//         console.error("Error adding to cart:", error);
//         toast.error("حدث خطأ أثناء إضافة المنتج للسلة");
//       } finally {
//         setIsLoading(false);
//       }
//     },
//     [token, transformBackendToFrontend, clearCheckoutSession]
//   );

//   // Remove item from cart
//   const removeFromCart = useCallback(
//     async (productId, variantId, withoutBox = false) => {
//       try {
//         setIsLoading(true);

//         if (token) {
//           await CartsApiService.removeFromCart(variantId, withoutBox);

//           const backendCart = await CartsApiService.getCart();
//           const transformedItems = transformBackendToFrontend(
//             backendCart.items
//           );
//           setCartItems(transformedItems);
//         } else {
//           setCartItems((prevItems) => {
//             const updatedItems = prevItems.filter(
//               (item) =>
//                 !(
//                   item.product.id === productId &&
//                   item.variant.id === variantId &&
//                   item.withoutBox === withoutBox
//                 )
//             );

//             localStorage.setItem("cart", JSON.stringify(updatedItems));
//             return updatedItems;
//           });

//           clearCheckoutSession();
//         }
//       } catch (error) {
//         console.error("Error removing from cart:", error);
//       } finally {
//         setIsLoading(false);
//       }
//     },
//     [token, transformBackendToFrontend, clearCheckoutSession]
//   );

//   // Update item quantity
//   const updateQuantity = useCallback(
//     async (productId, variantId, newQuantity, withoutBox = false) => {
//       try {
//         if (newQuantity <= 0) {
//           await removeFromCart(productId, variantId, withoutBox);
//           return;
//         }

//         setIsLoading(true);

//         const item = cartItems.find(
//           (i) => i.variant.id === variantId && i.withoutBox === withoutBox
//         );
//         if (!item) {
//           setIsLoading(false);
//           return;
//         }

//         const maxQuantity = withoutBox
//           ? item.variant.withoutBoxQuantity
//           : item.variant.quantity;
//         let validatedQuantity = newQuantity;

//         if (newQuantity > maxQuantity) {
//           validatedQuantity = maxQuantity;
//           toast.warning(`الكمية المتاحة هي ${maxQuantity} فقط`);
//         }

//         if (token) {
//           await CartsApiService.updateCartItemByVariant(
//             variantId,
//             validatedQuantity,
//             withoutBox
//           );

//           const backendCart = await CartsApiService.getCart();
//           const transformedItems = transformBackendToFrontend(
//             backendCart.items
//           );
//           setCartItems(transformedItems);
//         } else {
//           setCartItems((prevItems) => {
//             const updatedItems = prevItems.map((item) =>
//               item.product.id === productId &&
//               item.variant.id === variantId &&
//               item.withoutBox === withoutBox
//                 ? { ...item, quantity: validatedQuantity }
//                 : item
//             );

//             localStorage.setItem("cart", JSON.stringify(updatedItems));
//             return updatedItems;
//           });

//           clearCheckoutSession();
//         }
//       } catch (error) {
//         console.error("Error updating quantity:", error);
//       } finally {
//         setIsLoading(false);
//       }
//     },
//     [
//       token,
//       removeFromCart,
//       cartItems,
//       transformBackendToFrontend,
//       clearCheckoutSession,
//     ]
//   );

//   // Clear cart
//   const clearCart = useCallback(async () => {
//     try {
//       setIsLoading(true);

//       if (token) {
//         await CartsApiService.clearCart();
//       }

//       setCartItems([]);
//       setCartFromBackend(null);
//       localStorage.removeItem("cart");

//       clearCheckoutSession();
//     } catch (error) {
//       console.error("Error clearing cart:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   }, [token, clearCheckoutSession]);

//   // Check item availability
//   const checkAvailability = useCallback(
//     async (productVariantId, quantity, withoutBox = false) => {
//       try {
//         if (token) {
//           return await CartsApiService.checkAvailability(
//             productVariantId,
//             quantity,
//             withoutBox
//           );
//         }
//         return true;
//       } catch (error) {
//         console.error("Error checking availability:", error);
//         return false;
//       }
//     },
//     [token]
//   );

//   // Get cart item count
//   const getCartItemCount = useCallback(async () => {
//     if (token) {
//       try {
//         const count = await CartsApiService.getCartItemCount();
//         return count;
//       } catch (error) {
//         console.error("Error getting cart count:", error);
//       }
//     }
//     return cartItems.reduce((count, item) => count + (item.quantity || 0), 0);
//   }, [token, cartItems]);

//   // Toggle cart drawer
//   const toggleCart = useCallback(() => {
//     setIsCartOpen((prev) => !prev);
//   }, []);

//   const openCart = useCallback(() => {
//     setIsCartOpen(true);
//   }, []);

//   const closeCart = useCallback(() => {
//     setIsCartOpen(false);
//   }, []);

//   // Calculate totals
//   const subtotal = cartItems.reduce((total, item) => {
//     let price = 0;
//     if (item.withoutBox) {
//       price = item.variant.discountPrice
//         ? item.variant.discountPrice - 100
//         : item.variant.price - 100;
//     } else {
//       price = item.variant.discountPrice || item.variant.price || 0;
//     }
//     return total + price * item.quantity;
//   }, 0);

//   const shipping = 0;
//   const total = subtotal;

//   const cartCount = cartItems.reduce(
//     (count, item) => count + (item.quantity || 0),
//     0
//   );

//   const value = {
//     cartItems,
//     setCartItems,
//     isCartOpen,
//     setIsCartOpen,
//     cartCount,
//     subtotal,
//     shipping,
//     total,
//     isLoading,
//     cartFromBackend,
//     checkoutSession,
//     setCartFromBackend,
//     loadCartFromLocalStorage,
//     transformBackendToFrontend,
//     addToCart,
//     removeFromCart,
//     updateQuantity,
//     clearCart,
//     checkAvailability,
//     getCartItemCount,
//     toggleCart,
//     openCart,
//     closeCart,
//     prepareCheckoutItems,
//     checkCartAvailability,
//     initiateCheckout,
//     clearCheckoutSession,
//     validateCheckoutSession,
//     updateCartWithAvailableQuantities,
//   };

//   return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
// };

import {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import { useAuth } from "./AuthContext";
import CartsApiService from "../services/CartsApiService";
import OrderApiService from "../services/OrderApiService";
import { toast } from "react-toastify";

const CartContext = createContext();

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error("useCart must be used within CartProvider");
  }
  return context;
};

export const CartProvider = ({ children }) => {
  const { user, token } = useAuth();
  const [cartItems, setCartItems] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [cartFromBackend, setCartFromBackend] = useState(null);
  const [checkoutSession, setCheckoutSession] = useState(null);

  // Transform backend cart items to frontend format
  const transformBackendToFrontend = useCallback((backendItems) => {
    if (!backendItems || !Array.isArray(backendItems)) return [];

    const frontendItems = [];

    backendItems.forEach((item) => {
      const baseItem = {
        id: item.id,
        product: {
          id: item.product?.id || 0,
          nameEn: item.product?.name_en || item.product?.nameEn || "",
          nameAr: item.product?.name_ar || item.product?.nameAr || "",
          images:
            item.product?.images?.map((img) => ({
              image_url: img.imageUrl || img.image_url || "",
            })) || [],
          brand: item.product?.brand
            ? {
                id: item.product.brand.id,
                nameEn:
                  item.product.brand.nameEn || item.product.brand.name_en || "",
                nameAr:
                  item.product.brand.nameAr || item.product.brand.name_ar || "",
                imageUrl:
                  item.product.brand.imageUrl ||
                  item.product.brand.image_url ||
                  null,
              }
            : null,
          descriptionEn:
            item.product?.description_en || item.product?.descriptionEn || "",
          descriptionAr:
            item.product?.description_ar || item.product?.descriptionAr || "",
          category: item.product?.category || null,
          subCategory:
            item.product?.subCategory || item.product?.sub_category || null,
          collection: item.product?.collection || null,
        },
        variant: {
          id: item.variant?.id || 0,
          color: item.variant?.color || null,
          size: item.variant?.size || null,
          price: item.variant?.price || 0,
          discountPrice: item.variant?.discountPrice || null,
          availableQuantity: item.variant?.availableQuantity || 0,
          withoutBoxQuantity: item.variant?.withoutBoxQuantity || 0,
          quantity: item.variant?.quantity || 0,
          sku: item.variant?.sku || "",
        },
        itemTotal: item.itemTotal || 0,
      };

      // Add with-box item if quantity > 0
      if (item.quantity && item.quantity > 0) {
        frontendItems.push({
          ...baseItem,
          quantity: item.quantity,
          withoutBox: false,
        });
      }

      // Add without-box item if withoutBoxQuantity > 0
      if (item.withoutBoxQuantity && item.withoutBoxQuantity > 0) {
        frontendItems.push({
          ...baseItem,
          quantity: item.withoutBoxQuantity,
          withoutBox: true,
        });
      }
    });

    return frontendItems;
  }, []);

  // ✅ IMPROVED: Sync local cart to backend
  const syncLocalCartToBackend = async (localCartItems) => {
    try {
      console.log("🔄 Starting cart sync...");
      
      // ✅ STEP 1: Get existing backend cart first
      let backendCart;
      try {
        backendCart = await CartsApiService.getCart();
      } catch (error) {
        console.error("Error fetching backend cart:", error);
        // If backend cart doesn't exist, create empty one
        backendCart = { items: [] };
      }

      // ✅ STEP 2: Create a map of existing backend items
      const backendItemsMap = new Map();
      
      if (backendCart.items && backendCart.items.length > 0) {
        backendCart.items.forEach((item) => {
          // Create keys for both with-box and without-box variants
          if (item.quantity && item.quantity > 0) {
            const keyWith = `${item.variant.id}-with`;
            backendItemsMap.set(keyWith, {
              variantId: item.variant.id,
              quantity: item.quantity,
              withoutBox: false,
            });
          }
          
          if (item.withoutBoxQuantity && item.withoutBoxQuantity > 0) {
            const keyWithout = `${item.variant.id}-without`;
            backendItemsMap.set(keyWithout, {
              variantId: item.variant.id,
              quantity: item.withoutBoxQuantity,
              withoutBox: true,
            });
          }
        });
      }

      // ✅ STEP 3: Group local items by variantId and withoutBox
      const localItemsMap = new Map();
      
      localCartItems.forEach((item) => {
        const key = `${item.variant.id}-${item.withoutBox ? "without" : "with"}`;
        if (localItemsMap.has(key)) {
          // Sum quantities if duplicate
          localItemsMap.get(key).quantity += item.quantity;
        } else {
          localItemsMap.set(key, {
            productVariantId: item.variant.id,
            quantity: item.quantity,
            withoutBox: item.withoutBox || false,
          });
        }
      });

      // ✅ STEP 4: Process each local item
      for (const [key, localItem] of localItemsMap.entries()) {
        const backendItem = backendItemsMap.get(key);

        if (backendItem) {
          // Item exists in backend
          // ✅ Compare quantities and update if local has more
          if (localItem.quantity > backendItem.quantity) {
            console.log(
              `📦 Updating quantity for variant ${localItem.productVariantId} (${localItem.withoutBox ? "without box" : "with box"}): ${backendItem.quantity} → ${localItem.quantity}`
            );
            
            try {
              await CartsApiService.updateCartItemByVariant(
                localItem.productVariantId,
                localItem.quantity,
                localItem.withoutBox
              );
            } catch (error) {
              console.error(`Error updating variant ${localItem.productVariantId}:`, error);
            }
          } else {
            console.log(
              `✅ Variant ${localItem.productVariantId} (${localItem.withoutBox ? "without box" : "with box"}) already in backend with equal/higher quantity. Skipping.`
            );
          }
        } else {
          // Item doesn't exist in backend - add it
          console.log(
            `➕ Adding new item to backend: variant ${localItem.productVariantId} (${localItem.withoutBox ? "without box" : "with box"}), quantity: ${localItem.quantity}`
          );
          
          try {
            await CartsApiService.addToCart(
              localItem.productVariantId,
              localItem.quantity,
              localItem.withoutBox
            );
          } catch (error) {
            console.error(`Error adding variant ${localItem.productVariantId}:`, error);
          }
        }
      }

      console.log("✅ Cart sync completed successfully!");
    } catch (error) {
      console.error("❌ Error syncing cart to backend:", error);
    }
  };

  // Initialize cart based on auth state
  useEffect(() => {
    const initializeCart = async () => {
      if (token && user) {
        // User is logged in - load from backend
        try {
          setIsLoading(true);

          // Check for local cart to sync
          const localCart = localStorage.getItem("cart");
          if (localCart) {
            const localCartItems = JSON.parse(localCart);
            if (localCartItems.length > 0) {
              console.log("📦 Found local cart with items, syncing to backend...");
              // Sync local cart to backend (improved version)
              await syncLocalCartToBackend(localCartItems);
              // Clear localStorage after sync
              localStorage.removeItem("cart");
              console.log("🗑️ Local cart cleared after sync");
            }
          }

          // Load cart from backend
          const backendCart = await CartsApiService.getCart();
          setCartFromBackend(backendCart);

          // Set cart items from backend (transformed)
          const transformedItems = transformBackendToFrontend(
            backendCart.items
          );
          setCartItems(transformedItems);
        } catch (error) {
          console.error("Error loading cart from backend:", error);
          // Fallback to localStorage if backend fails
          loadCartFromLocalStorage();
        } finally {
          setIsLoading(false);
        }
      } else {
        // User is not logged in - load from localStorage
        loadCartFromLocalStorage();

        // Check for existing checkout session
        const savedCheckoutSession = localStorage.getItem("checkoutSession");
        if (savedCheckoutSession) {
          try {
            setCheckoutSession(JSON.parse(savedCheckoutSession));
          } catch (e) {
            console.error("Error parsing checkout session:", e);
          }
        }
      }
    };

    initializeCart();
  }, [token, user, transformBackendToFrontend]);

  // Load cart from localStorage
  const loadCartFromLocalStorage = () => {
    const savedCart = localStorage.getItem("cart");
    if (savedCart) {
      try {
        setCartItems(JSON.parse(savedCart));
      } catch (error) {
        console.error("Error loading cart from localStorage:", error);
      }
    }
  };

  // Save to localStorage only if user is not logged in
  useEffect(() => {
    if (!token) {
      localStorage.setItem("cart", JSON.stringify(cartItems));
    }
  }, [cartItems, token]);

  // Prepare cart items for checkout
  const prepareCheckoutItems = useCallback(() => {
    if (!cartItems || cartItems.length === 0) return [];

    return cartItems.map((item) => ({
      productVariantId: item.variant.id,
      quantity: item.quantity,
      withoutBox: item.withoutBox || false,
    }));
  }, [cartItems]);

  // Check cart items availability before checkout
  const checkCartAvailability = useCallback(async () => {
    try {
      const checkoutItems = prepareCheckoutItems();

      if (checkoutItems.length === 0) {
        return { success: true, unavailableItems: [] };
      }

      const result = await OrderApiService.checkCartAvailability(checkoutItems);
      return result;
    } catch (error) {
      console.error("Error checking cart availability:", error);
      return { success: false, error: error.message };
    }
  }, [prepareCheckoutItems]);

  // Update cart with available quantities
  const updateCartWithAvailableQuantities = useCallback(
    (updatedCartItems) => {
      if (token) {
        // For logged-in users: refresh cart from backend
        const refreshCart = async () => {
          try {
            const backendCart = await CartsApiService.getCart();
            setCartFromBackend(backendCart);
            const transformedItems = transformBackendToFrontend(backendCart.items);
            setCartItems(transformedItems);
          } catch (error) {
            console.error("Error refreshing cart:", error);
          }
        };
        refreshCart();
      } else {
        // For guest users: update localStorage cart
        setCartItems((prevItems) => {
          const updatedItems = [...prevItems];

          updatedCartItems.forEach((update) => {
            const itemIndex = updatedItems.findIndex(
              (item) =>
                item.variant.id === update.productVariantId &&
                item.withoutBox === update.withoutBox
            );

            if (itemIndex !== -1) {
              if (update.shouldRemove || update.quantity === 0) {
                updatedItems.splice(itemIndex, 1);
              } else if (update.quantity > 0) {
                updatedItems[itemIndex] = {
                  ...updatedItems[itemIndex],
                  quantity: update.quantity,
                };
              }
            }
          });

          localStorage.setItem("cart", JSON.stringify(updatedItems));
          return updatedItems;
        });
      }
    },
    [token, transformBackendToFrontend]
  );

  // Initiate checkout process
  const initiateCheckout = useCallback(async () => {
    try {
      setIsLoading(true);

      const checkoutItems = prepareCheckoutItems();
      const useCartItems = !!user;

      const response = await OrderApiService.initiateCheckout(
        useCartItems ? [] : checkoutItems,
        useCartItems
      );

      if (!response.success) {
        if (response.updatedCartItems && response.updatedCartItems.length > 0) {
          updateCartWithAvailableQuantities(response.updatedCartItems);
        } else if (response.unavailableItems && response.unavailableItems.length > 0) {
          if (user && token) {
            try {
              const backendCart = await CartsApiService.getCart();
              setCartFromBackend(backendCart);
              const transformedItems = transformBackendToFrontend(backendCart.items);
              setCartItems(transformedItems);
            } catch (error) {
              console.error("Error refreshing cart:", error);
            }
          }
        }

        return {
          success: false,
          unavailableItems: response.unavailableItems || [],
          errorMessage:
            response.errorMessage ||
            "Some items are not available in the requested quantities",
        };
      }

      setCheckoutSession({
        checkoutId: response.checkoutId,
        expiresAt: response.expiresAt,
        expiresIn: response.expiresIn,
      });

      if (!user) {
        localStorage.setItem(
          "checkoutSession",
          JSON.stringify({
            checkoutId: response.checkoutId,
            expiresAt: response.expiresAt,
            expiresIn: response.expiresIn,
          })
        );

        localStorage.setItem("checkoutCartItems", JSON.stringify(checkoutItems));
      }

      return {
        success: true,
        checkoutId: response.checkoutId,
        expiresAt: response.expiresAt,
        expiresIn: response.expiresIn,
      };
    } catch (error) {
      console.error("Error initiating checkout:", error);
      return {
        success: false,
        errorMessage: error.message || "Failed to initiate checkout",
      };
    } finally {
      setIsLoading(false);
    }
  }, [prepareCheckoutItems, user, token, updateCartWithAvailableQuantities, transformBackendToFrontend]);

  // Clear checkout session
  const clearCheckoutSession = useCallback(() => {
    setCheckoutSession(null);
    localStorage.removeItem("checkoutSession");
    localStorage.removeItem("checkoutCartItems");
  }, []);

  // Validate checkout session
  const validateCheckoutSession = useCallback(async (checkoutId) => {
    try {
      const session = await OrderApiService.getCheckoutSession(checkoutId);

      if (
        session.status === "PENDING" &&
        new Date(session.expiresAt) > new Date()
      ) {
        return { valid: true, session };
      }

      return { valid: false, session };
    } catch (error) {
      console.error("Error validating checkout session:", error);
      return { valid: false, error: error.message };
    }
  }, []);

  // Add item to cart
  const addToCart = useCallback(
    async (
      product,
      variant,
      quantity = 1,
      withoutBox = false,
      autoOpen = true
    ) => {
      try {
        setIsLoading(true);

        const maxQuantity = withoutBox
          ? (variant.withoutBoxQuantity - variant.withoutBoxReservedQuantity)
          : (variant.quantity - variant.reservedQuantity);
        let validatedQuantity = quantity;

        if (validatedQuantity <= 0) {
          toast.error(
            withoutBox
              ? "عذراً، هذا المنتج غير متوفر بدون صندوق حالياً"
              : "عذراً، هذا المنتج غير متوفر حالياً"
          );
          setIsLoading(false);
          return;
        }

        if (quantity > maxQuantity) {
          validatedQuantity = maxQuantity;

          const message = withoutBox
            ? `الكمية المتاحة بدون صندوق هي ${maxQuantity} فقط. تم تعديل الكمية.`
            : `الكمية المتاحة هي ${maxQuantity} فقط. تم تعديل الكمية.`;

          toast.warning(message);
        }

        if (token) {
          const response = await CartsApiService.addToCart(
            variant.id,
            validatedQuantity,
            withoutBox
          );

          setCartFromBackend(response);
          const transformedItems = transformBackendToFrontend(response.items);
          setCartItems(transformedItems);
        } else {
          setCartItems((prevItems) => {
            const existingItemIndex = prevItems.findIndex(
              (item) =>
                item.product.id === product.id &&
                item.variant.id === variant.id &&
                item.withoutBox === withoutBox
            );

            if (existingItemIndex > -1) {
              const updatedItems = [...prevItems];
              const newQuantity =
                updatedItems[existingItemIndex].quantity + validatedQuantity;

              if (newQuantity > maxQuantity) {
                updatedItems[existingItemIndex].quantity = maxQuantity;
              } else {
                updatedItems[existingItemIndex].quantity = newQuantity;
              }

              return updatedItems;
            } else {
              return [
                ...prevItems,
                {
                  id: Date.now(),
                  product,
                  variant,
                  quantity: validatedQuantity,
                  withoutBox,
                },
              ];
            }
          });

          clearCheckoutSession();
        }

        if (autoOpen) {
          setIsCartOpen(true);
        }
      } catch (error) {
        console.error("Error adding to cart:", error);
        toast.error("حدث خطأ أثناء إضافة المنتج للسلة");
      } finally {
        setIsLoading(false);
      }
    },
    [token, transformBackendToFrontend, clearCheckoutSession]
  );

  // Remove item from cart
  const removeFromCart = useCallback(
    async (productId, variantId, withoutBox = false) => {
      try {
        setIsLoading(true);

        if (token) {
          await CartsApiService.removeFromCart(variantId, withoutBox);

          const backendCart = await CartsApiService.getCart();
          const transformedItems = transformBackendToFrontend(
            backendCart.items
          );
          setCartItems(transformedItems);
        } else {
          setCartItems((prevItems) => {
            const updatedItems = prevItems.filter(
              (item) =>
                !(
                  item.product.id === productId &&
                  item.variant.id === variantId &&
                  item.withoutBox === withoutBox
                )
            );

            localStorage.setItem("cart", JSON.stringify(updatedItems));
            return updatedItems;
          });

          clearCheckoutSession();
        }
      } catch (error) {
        console.error("Error removing from cart:", error);
      } finally {
        setIsLoading(false);
      }
    },
    [token, transformBackendToFrontend, clearCheckoutSession]
  );

  // Update item quantity
  const updateQuantity = useCallback(
    async (productId, variantId, newQuantity, withoutBox = false) => {
      try {
        if (newQuantity <= 0) {
          await removeFromCart(productId, variantId, withoutBox);
          return;
        }

        setIsLoading(true);

        const item = cartItems.find(
          (i) => i.variant.id === variantId && i.withoutBox === withoutBox
        );
        if (!item) {
          setIsLoading(false);
          return;
        }

        const maxQuantity = withoutBox
          ? item.variant.withoutBoxQuantity
          : item.variant.quantity;
        let validatedQuantity = newQuantity;

        if (newQuantity > maxQuantity) {
          validatedQuantity = maxQuantity;
          toast.warning(`الكمية المتاحة هي ${maxQuantity} فقط`);
        }

        if (token) {
          await CartsApiService.updateCartItemByVariant(
            variantId,
            validatedQuantity,
            withoutBox
          );

          const backendCart = await CartsApiService.getCart();
          const transformedItems = transformBackendToFrontend(
            backendCart.items
          );
          setCartItems(transformedItems);
        } else {
          setCartItems((prevItems) => {
            const updatedItems = prevItems.map((item) =>
              item.product.id === productId &&
              item.variant.id === variantId &&
              item.withoutBox === withoutBox
                ? { ...item, quantity: validatedQuantity }
                : item
            );

            localStorage.setItem("cart", JSON.stringify(updatedItems));
            return updatedItems;
          });

          clearCheckoutSession();
        }
      } catch (error) {
        console.error("Error updating quantity:", error);
      } finally {
        setIsLoading(false);
      }
    },
    [
      token,
      removeFromCart,
      cartItems,
      transformBackendToFrontend,
      clearCheckoutSession,
    ]
  );

  // Clear cart
  const clearCart = useCallback(async () => {
    try {
      setIsLoading(true);

      if (token) {
        await CartsApiService.clearCart();
      }

      setCartItems([]);
      setCartFromBackend(null);
      localStorage.removeItem("cart");

      clearCheckoutSession();
    } catch (error) {
      console.error("Error clearing cart:", error);
    } finally {
      setIsLoading(false);
    }
  }, [token, clearCheckoutSession]);

  // Check item availability
  const checkAvailability = useCallback(
    async (productVariantId, quantity, withoutBox = false) => {
      try {
        if (token) {
          return await CartsApiService.checkAvailability(
            productVariantId,
            quantity,
            withoutBox
          );
        }
        return true;
      } catch (error) {
        console.error("Error checking availability:", error);
        return false;
      }
    },
    [token]
  );

  // Get cart item count
  const getCartItemCount = useCallback(async () => {
    if (token) {
      try {
        const count = await CartsApiService.getCartItemCount();
        return count;
      } catch (error) {
        console.error("Error getting cart count:", error);
      }
    }
    return cartItems.reduce((count, item) => count + (item.quantity || 0), 0);
  }, [token, cartItems]);

  // Toggle cart drawer
  const toggleCart = useCallback(() => {
    setIsCartOpen((prev) => !prev);
  }, []);

  const openCart = useCallback(() => {
    setIsCartOpen(true);
  }, []);

  const closeCart = useCallback(() => {
    setIsCartOpen(false);
  }, []);

  // ✅ NEW: Check if product variant is in cart
  const isInCart = useCallback(
    (variantId, withoutBox = false) => {
      return cartItems.some(
        (item) => item.variant.id === variantId && item.withoutBox === withoutBox
      );
    },
    [cartItems]
  );

  // ✅ NEW: Get cart item by variant ID
  const getCartItem = useCallback(
    (variantId, withoutBox = false) => {
      return cartItems.find(
        (item) => item.variant.id === variantId && item.withoutBox === withoutBox
      );
    },
    [cartItems]
  );

  // ✅ NEW: Get total quantity for a variant (both with and without box)
  const getVariantTotalQuantity = useCallback(
    (variantId) => {
      return cartItems
        .filter((item) => item.variant.id === variantId)
        .reduce((total, item) => total + item.quantity, 0);
    },
    [cartItems]
  );

  // Calculate totals
  const subtotal = cartItems.reduce((total, item) => {
    let price = 0;
    if (item.withoutBox) {
      price = item.variant.discountPrice
        ? item.variant.discountPrice - 100
        : item.variant.price - 100;
    } else {
      price = item.variant.discountPrice || item.variant.price || 0;
    }
    return total + price * item.quantity;
  }, 0);

  const shipping = 0;
  const total = subtotal;

  const cartCount = cartItems.reduce(
    (count, item) => count + (item.quantity || 0),
    0
  );

  const value = {
    cartItems,
    setCartItems,
    isCartOpen,
    setIsCartOpen,
    cartCount,
    subtotal,
    shipping,
    total,
    isLoading,
    cartFromBackend,
    checkoutSession,
    setCartFromBackend,
    loadCartFromLocalStorage,
    transformBackendToFrontend,
    addToCart,
    removeFromCart,
    updateQuantity,
    clearCart,
    checkAvailability,
    getCartItemCount,
    toggleCart,
    openCart,
    closeCart,
    prepareCheckoutItems,
    checkCartAvailability,
    initiateCheckout,
    clearCheckoutSession,
    validateCheckoutSession,
    updateCartWithAvailableQuantities,
    isInCart,
    getCartItem,
    getVariantTotalQuantity,
  };

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};